module.exports = __webpack_public_path__ + "img/7.e45e4e52.png";